import WPStagingCommon from '../../wpstg.js';
import {qs} from '../../modules/wpstg-dom-utils.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupEdit;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupEdit.listen();
  });

  WPStagingBackupEdit = {
    listen() {
      $('#wpstg--tab--backup')
          .off('click', '.wpstg--backup--edit[data-md5]', WPStagingBackupEdit.edit)
          .on('click', '.wpstg--backup--edit[data-md5]', WPStagingBackupEdit.edit);
    },
    async edit(e) {
      e.preventDefault();

      const $this = $(this);
      const name = $this.data('name');
      const notes = $this.data('notes');

      const {value: formValues} = await WPStagingCommon.getSwalModal().fire({
        title: '',
        html: `
                    <label id="wpstg-backup-edit-name">Backup Name</label>
                    <input id="wpstg-backup-edit-name-input" class="wpstg--swal2-input" value="${name}" maxlength="100">
                    <label>Additional Notes</label>
                    <textarea id="wpstg-backup-edit-notes-textarea" class="wpstg--swal2-textarea" maxlength="1000">${notes}</textarea>
                  `,
        focusConfirm: false,
        confirmButtonText: 'Save',
        showCancelButton: true,
        preConfirm: () => ({
          name: document.getElementById('wpstg-backup-edit-name-input').value || null,
          notes: document.getElementById('wpstg-backup-edit-notes-textarea').value || null,
        }),
      });

      if (!formValues) {
        return;
      }

      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--edit',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            md5: $this.data('md5'),
            name: formValues.name,
            notes: formValues.notes,
          },
          function(response) {
            WPStagingCommon.showAjaxFatalError(response, '', 'Submit an error report.');
            // noinspection JSIgnoredPromiseFromCall
            WPStagingBackup.fetchListing();
          },
      );
    },
  };
}(jQuery));

export default WPStagingBackupEdit;
